export const Spacer = () => (<div style={{display: 'flex', flex: 1}}></div>)